import { render } from "./StreamManageHighlights.vue?vue&type=template&id=b94fc5a6&scoped=true"
import script from "./StreamManageHighlights.vue?vue&type=script&lang=js"
export * from "./StreamManageHighlights.vue?vue&type=script&lang=js"

import "./StreamManageHighlights.vue?vue&type=style&index=0&id=b94fc5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94fc5a6"]])

export default __exports__